// @flow
import React from 'react';
import { Flex, Box } from 'grid-styled';
import { Text } from '../Text';

const ICON_WIDTH = 16;

type Props = {
  name: string,
  color: string,
  isSelected: boolean,
  isHovered: boolean,
  onClick(): void,
  onMouseOver(): void,
  onMouseOut(): void,
};

const LegendItem = ({
  name,
  color,
  isSelected,
  isHovered,
  onClick,
  onMouseOver,
  onMouseOut,
}: Props) => (
  <Flex
    alignItems="center"
    width={160}
    onClick={onClick}
    onMouseOver={onMouseOver}
    onMouseOut={onMouseOut}
    bg={isSelected || isHovered ? 'hoveredBg' : 'white'}
    style={{
      height: 32,
      cursor: 'pointer',
    }}
  >
    <Box
      m={1}
      width={ICON_WIDTH}
      flex="0 0 auto"
      bg={color}
      style={{
        height: isSelected ? ICON_WIDTH : ICON_WIDTH / 2,
      }}
    />
    <Text
      is="div"
      style={{ flex: '1 1 auto', marginRight: 8 }}
      fontWeight={isSelected || isHovered ? 700 : 300}
      fontSize="16px"
      truncate
    >
      {name}
    </Text>
  </Flex>
);

export default LegendItem;



// WEBPACK FOOTER //
// ./src/components/FlexChartLegend/LegendItem.jsx